import { Component, OnInit, Input } from '@angular/core';
import { Lagerplatz } from '../models/lagerplatz.model';

@Component({
  selector: 'sws-lagerartikelzeile',
  templateUrl: './lagerartikelzeile.component.html',
  styleUrls: ['./lagerartikelzeile.component.css']
})
export class LagerartikelzeileComponent implements OnInit {
 @Input() platz: Lagerplatz;
 
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/lagerartikelzeile/lagerartikelzeile.component.ts